const catalogs = {
  title: 'Catalogs',
  menu: 'Catalogs',
  newName: 'New value',
  rename: 'Rename',
  created: 'Value created successfully',
  renamed: 'Value renamed successfully',
  merged: 'Values merged successfully',
  deleted: 'Value deleted successfully',
  error: 'The operation could not be completed',
  empty: 'This catalog has no values',
  mergeConfirm:
    '"%{target}" already exists. "%{source}" will be merged into "%{target}" and every contact will point to the existing value. Continue?',
  deleteConfirm: 'Delete "%{name}"?',
  deleteConfirmUsed:
    '"%{name}" is assigned to %{count} record(s). Deleting it will unassign all of them. Continue?',
  columns: {
    name: 'Name',
    usage: 'In use',
  },
  types: {
    tags: 'Tags',
    interests: 'Interests',
    'job-titles': 'Job titles',
    companies: 'Companies',
    'contact-types': 'Contact types',
    'lead-sources': 'Sources',
    'hotel-categories': 'Categories',
    'pms-systems': 'PMS',
    'lock-systems': 'Lock systems',
    'payment-processors': 'Payment processors',
  },
};

export default catalogs;
